// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter--container[data-v-cf0bfda6] {\n  width: 100%;\n}\n.filter--select[data-v-cf0bfda6] {\n  width: 18.75rem;\n}\n.form-title[data-v-cf0bfda6] {\n  display: flex;\n}\ntr[data-v-cf0bfda6] {\n  background-color: #ffffff;\n}\ntr[data-v-cf0bfda6]:nth-child(odd) {\n  background-color: #f6f6f6;\n}", ""]);
// Exports
module.exports = exports;
